import React from 'react';
export var CBNationaleCardArt = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    height: "24px",
    version: "1.1",
    viewBox: "0 0 38 24",
    width: "38px",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "cbnationale-card-art-title"
  }, title), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "53.06%",
    x2: "50%",
    y1: "31.327%",
    y2: "68.673%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#003F7D"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#00A36E"
  }))), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1"
  }, React.createElement("g", {
    fillRule: "nonzero",
    id: "Production-assets-sharing",
    transform: "translate(-139.000000, -163.000000)"
  }, React.createElement("g", {
    id: "result-(1)",
    transform: "translate(139.000000, 163.000000)"
  }, React.createElement("path", {
    d: "M35,0 L3,0 C1.3,0 0,1.3 0,3 L0,21 C0,22.7 1.4,24 3,24 L35,24 C36.7,24 38,22.7 38,21 L38,3 C38,1.3 36.6,0 35,0 Z",
    fill: "#000000",
    id: "Path",
    opacity: "0.07"
  }), React.createElement("path", {
    d: "M37,3 L37,21 C37,22.1 36.1,23 35,23 L3,23 C1.9,23 1,22.1 1,21 L1,3 C1,1.9 1.9,1 3,1 L35,1 C36.1,1 37,1.9 37,3 Z",
    fill: "url(#linearGradient-1)",
    id: "Path"
  }), React.createElement("g", {
    fill: "#FFFFFF",
    id: "Group",
    transform: "translate(3.000000, 5.000000)"
  }, React.createElement("path", {
    d: "M28.258,0.00064356 L16.405,0 L16.405,6.761 L28.258,6.761 L28.258,6.7573532 C30.1043,6.7541354 31.6002,5.2426532 31.6002,3.3788532 C31.6002,1.5150532 30.1044,0.0035532 28.258,0.0005532 L28.258,0.00064356 Z",
    id: "b"
  }), React.createElement("path", {
    d: "M31.6,10.571 C31.6,8.7072 30.1042,7.196 28.2578,7.1927 L16.4048,7.19227096 L16.4048,13.953471 L28.2578,13.953471 L28.2578,13.9491806 C30.1041,13.9461773 31.6,12.4350806 31.6,10.5708806 L31.6,10.571 Z",
    id: "Path"
  }), React.createElement("path", {
    d: "M8.1,0 C12.2421,0 15.6,3.134 15.6,7 L15.595,6.779 L7.6977,6.78 L7.6977,7.15333 L15.5982,7.15324132 C15.510862,10.9484413 12.1872,14.0000413 8.1,14.0000413 C3.9579,14.0000413 0.6,10.8660413 0.6,7.00004132 C0.6,3.13404132 3.9579,0 8.1,0 L8.1,0 Z",
    id: "Path"
  }))))));
};
CBNationaleCardArt.defaultProps = {
  title: 'Confinoga'
};